//slide jQuery
var $ttiImageArea = $(".js-tti-image-area");

if ($ttiImageArea) {
    var $slides = $ttiImageArea.find("img");

    setInterval(function () {
        slideshow($slides);
    }, 600);
}

function slideshow($slides) {
    var $active = $slides.closest(".is-active");
    $active.removeClass("is-active");
    var $next = $active.next();
    if ($next.length === 0) {
        $next = $slides.closest(".first");
    }
    $next.addClass("is-active");
}
